import { Component, EventEmitter, OnInit } from '@angular/core';
import { Input } from "@angular/core";
import { Output } from "@angular/core";


@Component({
    selector: 'app-paginator',
    templateUrl: './paginator.component.html',
    styleUrls: ['./paginator.component.scss']
})
export class PaginatorComponent implements OnInit {

    @Input() pages: number;
    @Input() current: number;
    @Output() onChangePage: EventEmitter<any> = new EventEmitter();
    _pages = [];
    chPage = 1;

    constructor() {
    }

    ngOnInit() {
        if (this.pages <= 15) {
            for (let i = 1; i <= this.pages; i++) {
                this._pages.push(i);
            }
        } else {
            this.calc();
        }
    }

    calc() {
        this._pages = [];

        this._pages.push(1);
        this._pages.push(2);
        this._pages.push(3);

        if (this.current > 2 && this.current < Math.round(this.pages / 2) - 3) {
            if (this.current > 5) {
                this._pages.push('space');
            }
            if (this.current > 4) {
                this._pages.push(this.current - 1);
            }
            if (this.current > 3) {
                this._pages.push(this.current);
            }
            this._pages.push(this.current + 1);
        }

        this._pages.push('space');

        if (this.current == Math.round(this.pages / 2) - 3) {
            this._pages.push(Math.round(this.pages / 2) - 4);
            this._pages.push(Math.round(this.pages / 2) - 3);
            this._pages.push(Math.round(this.pages / 2) - 2);
        }
        if (this.current == Math.round(this.pages / 2) - 2) {
            this._pages.push(Math.round(this.pages / 2) - 3);
            this._pages.push(Math.round(this.pages / 2) - 2);
        }
        if (this.current == Math.round(this.pages / 2) - 1) {
            this._pages.push(Math.round(this.pages / 2) - 2);
        }
        this._pages.push(Math.round(this.pages / 2) - 1);
        this._pages.push(Math.round(this.pages / 2));
        this._pages.push(Math.round(this.pages / 2) + 1);
        if (this.current == Math.round(this.pages / 2) + 1) {
            this._pages.push(Math.round(this.pages / 2) + 2);
        }
        if (this.current == Math.round(this.pages / 2) + 2) {
            this._pages.push(Math.round(this.pages / 2) + 2);
            this._pages.push(Math.round(this.pages / 2) + 3);
        }
        if (this.current == Math.round(this.pages / 2) + 3) {
            this._pages.push(Math.round(this.pages / 2) + 2);
            this._pages.push(Math.round(this.pages / 2) + 3);
            this._pages.push(Math.round(this.pages / 2) + 4);
        }

        this._pages.push('space');

        if (this.current < this.pages - 1 && this.current > Math.round(this.pages / 2) + 3) {

            this._pages.push(this.current - 1);

            if (this.current < this.pages - 2) {
                this._pages.push(this.current);
            }
            if (this.current < this.pages - 3) {
                this._pages.push(this.current + 1);
            }
            if (this.current < this.pages - 4) {
                this._pages.push('space');
            }
        }

        this._pages.push(this.pages - 2);
        this._pages.push(this.pages - 1);
        this._pages.push(this.pages);
    }

    select(page) {
        this.current = page;
        if (this.pages > 15) {
            this.calc();
        }

        if (this.onChangePage) {
            this.onChangePage.emit(page);
        }
    }

    changePage() {
        this.select(this.chPage);
    }
}
